import React from 'react'

export default function NotFound() {
  return (
    <div>
        <img src="https://blogvault.net/wp-content/uploads/2020/10/Fixed-Sorry-you-are-not-allowed-to-access-this-page.png" alt='www' style={{height:"50%",width:"100%"}}></img>
        {/* <h1 style={{textAlign:"center",padding:"25%",backgroundColor:"gray"}}>You are not the authorised person for this page.</h1> */}
    </div>
  )
}
